import React from "react";
import { ErrorMessage, Form, Formik } from "formik";
import axios from "axios";
import { FIND_DOMAIN } from "../../_actions/endpoints";
import TldrVideoInAction from "../TldrVideoInAction";
import { Box, Button, ButtonGroup, Flex, Input, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const DomainNameForm = ({ props, onComplete, onError }) => {
  const { t } = useTranslation(["ai"]);
  return (
    <>
      <Formik
        initialValues={{ domain: "" }}
        validate={async (values) => {
          const errors = {};
          if (!values.domain) {
            errors.domain = t("url_validation");
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting, setErrors }) => {
          axios
            .get(`${FIND_DOMAIN}?domain=${values.domain}`)
            .then((response) => {
              if (response.data.statusCode === 422) {
                setErrors({
                  domain: t("domain_not_found_msg"),
                });
                setSubmitting(false);
                onComplete();
              } else {
                setSubmitting(false);
                onComplete(response.data);
              }
            })
            .catch((error) => {
              setSubmitting(false);
              onError();
            });
        }}
      >
        {({ isSubmitting, values, isValid, handleChange, handleBlur }) => (
          <>
            {
              <>
                <Text
                  fontSize="22px"
                  fontWeight="bold"
                  lineHeight="28px"
                  textAlign="center"
                  mr={["0.5", "0"]}
                >
                  {props.prompt.content.heroText}
                </Text>
                <Flex
                  justifyContent="center"
                  p="0"
                  fontSize="16px"
                  color="gray.300"
                  textAlign="center"
                >
                  {props.prompt.content.heroDescription}
                  {props.prompt.content.videoInAction !== "" && (
                    <TldrVideoInAction
                      title={props.prompt.title}
                      videoInAction={props.prompt.content.videoInAction}
                    />
                  )}
                </Flex>
                <br></br>
              </>
            }
            <Flex w="full" justifyContent="center">
              <Flex flexBasis="50%">
                <Form>
                  <div className="input-group">
                    <Box mb={1}>{t("enter_com_url")}</Box>
                    <Input
                      fontSize="md"
                      size="md"
                      type="text"
                      placeholder="Hint: Google.com"
                      aria-describedby="basic-addon1"
                      name="domain"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.domain}
                    />
                  </div>
                  <ErrorMessage
                    name="domain"
                    component="div"
                    className="error"
                  />

                  <Flex
                    justifyContent="center"
                    p="0"
                    fontSize="16px"
                    color="gray.300"
                    textAlign="left"
                    ml="0.5px"
                  >
                    {t("skip_msg")}
                  </Flex>

                  <Box className="input-group form-button" my={4}>
                    <ButtonGroup>
                      <Button
                        type="submit"
                        variant="outline"
                        onClick={() => onComplete()}
                      >
                        {t("skip", { ns: "common" })}
                      </Button>
                      <Button
                        type="submit"
                        variant="solid"
                        disabled={values.domain === "" || !isValid}
                        isLoading={isSubmitting}
                      >
                        {t("find_now")}
                      </Button>
                    </ButtonGroup>
                  </Box>
                </Form>
              </Flex>
            </Flex>
          </>
        )}
      </Formik>
    </>
  );
};

export default DomainNameForm;
